import React, { FunctionComponent } from "react";
import { Discount } from "../../models/Discount";
import { Currency } from "./Currency";

interface DiscountDescriptionProps {
  discount: Discount;
  children?: React.ReactNode;
}

export const DiscountDescription: FunctionComponent<
  DiscountDescriptionProps
> = ({ discount, children }) => {
  const renderDiscountDescription = (discount: Discount): any => {
    switch (discount.amountType) {
      case "Amount":
        if (discount.minimumPurchaseAmount) {
          return (
            <Currency value={discount.amount} currency={discount.currency}>
              {" "}
              off on total, if total exceeds{" "}
              <Currency
                value={discount.minimumPurchaseAmount}
                currency={discount.currency}
              />
            </Currency>
          );
        } else {
          return (
            <Currency value={discount.amount} currency={discount.currency}>
              {" "}
              off on total
            </Currency>
          );
        }
      case "Percentage":
        if (discount.minimumPurchaseAmount) {
          return (
            <>
              {discount.amount}% off on total, if total exceeds{" "}
              <Currency
                value={discount.minimumPurchaseAmount}
                currency={discount.currency}
              />
            </>
          );
        } else {
          return <>{discount.amount}% off on total</>;
        }
      default:
        return discount.amountType;
    }
  };
  return <>{renderDiscountDescription(discount)}</>;
};
